/* BEEBIR product cards, shade drawer and shared add-to-cart. Loaded once by sections that show BEEBIR cards. */
if (!customElements.get('beebir-product-card')) {
  const bpcDecode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };
 
  class BeebirProductCard extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const slides = this.querySelector('[data-slides]');
      const pips = [...this.querySelectorAll('.bpc__pips i')];
      const prev = this.querySelector('[data-img-prev]');
      const next = this.querySelector('[data-img-next]');
      const sync = () => {
        const i = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
        pips.forEach((p, k) => p.classList.toggle('is-on', k === i));
        if (prev) prev.hidden = i === 0;
        if (next) next.hidden = i >= pips.length - 1;
      };
      if (pips.length) slides.addEventListener('scroll', sync, { passive: true });
      prev?.addEventListener('click', () => slides.scrollBy({ left: -slides.clientWidth, behavior: 'smooth' }));
      next?.addEventListener('click', () => slides.scrollBy({ left: slides.clientWidth, behavior: 'smooth' }));
      this.querySelectorAll('[data-swatch]').forEach((sw) => sw.addEventListener('click', () => this.pick(sw)));
 
      const add = this.querySelector('[data-add]');
      add?.addEventListener('click', () => this.add(add));
      const open = this.querySelector('[data-open-qa]');
      open?.addEventListener('click', () => {
        const scope = this.closest('[data-bpc-scope]');
        const qa = scope && document.getElementById(scope.dataset.qaId);
        if (qa && qa.open) qa.open(this, open);
        else window.location.href = this.querySelector('[data-link]').href;
      });
    }
 
    pick(sw) {
      this.querySelectorAll('[data-swatch]').forEach((b) => b.setAttribute('aria-pressed', String(b === sw)));
      const main = this.querySelector('[data-main] img');
      if (main && sw.dataset.src) {
        main.removeAttribute('loading');
        main.srcset = sw.dataset.srcset || '';
        main.src = sw.dataset.src;
      }
      this.querySelector('[data-slides]')?.scrollTo({ left: 0, behavior: 'smooth' });
 
      const price = this.querySelector('[data-price]');
      price.querySelector('[data-now]').textContent = bpcDecode(sw.dataset.now);
      const was = price.querySelector('[data-was]');
      was.textContent = bpcDecode(sw.dataset.was);
      was.hidden = !sw.dataset.was;
      price.classList.toggle('is-sale', !!sw.dataset.was);
 
      const badge = this.querySelector('[data-badge]:not(.bpc-badge--sold)');
      if (badge) { badge.textContent = bpcDecode(sw.dataset.badge); badge.hidden = !sw.dataset.badge; }
      const name = this.querySelector('[data-shade-name]');
      if (name) name.textContent = bpcDecode(sw.dataset.name);
      if (sw.dataset.url) this.querySelectorAll('[data-link], [data-slides] a').forEach((a) => { a.href = sw.dataset.url; });
    }
 
    pickByName(name) {
      const sw = [...this.querySelectorAll('[data-swatch]')].find((s) => bpcDecode(s.dataset.name) === name);
      if (sw) this.pick(sw);
    }
 
    async add(btn) {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      btn.disabled = true;
      try {
        await window.BeebirCart.add(btn.dataset.add, 1);
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        const icon = btn.innerHTML;
        btn.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.5l3 3 6-7"/></svg>';
        setTimeout(() => { btn.innerHTML = icon; btn.classList.remove('is-done'); btn.disabled = false; }, 1600);
      } catch (e) {
        btn.classList.remove('is-busy');
        btn.disabled = false;
      }
    }
  }
  customElements.define('beebir-product-card', BeebirProductCard);
}
 
// Shared add-to-cart used by cards and the shade drawer. Tells the header and the BEEBIR cart drawer.
if (!window.BeebirCart) {
  window.BeebirCart = {
    add(id, quantity, openCart = true) {
      return this.addItems([{ id: Number(id), quantity: Number(quantity) || 1 }], openCart);
    },
    // items: [{ id, quantity }]. Used by the product page (main item + Pair it with).
    async addItems(items, openCart = true) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const item = await res.json();
      if (!res.ok) throw new Error(item.description || item.message || 'Could not add to cart');
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      document.dispatchEvent(new CustomEvent('beebir:cart:updated', { detail: { item_count: cart.item_count, cart, source: 'product-card' } }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, data: { itemCount: cart.item_count, source: 'beebir-featured' } } }));
      if (openCart) {
        const ev = new CustomEvent('beebir:cart:open', { cancelable: true });
        document.dispatchEvent(ev);
        // No BEEBIR cart drawer on the page: go to the cart page instead.
        if (!ev.defaultPrevented && !document.querySelector('beebir-cart-drawer')) window.location.href = root + 'cart';
      }
      return cart;
    },
  };
}
 
// Shade drawer (quick add). Each section has its own, moved to <body> so nothing clips it.
if (!customElements.get('beebir-quick-add')) {
  const bqaDecode = (s) => { const t = document.createElement('textarea'); t.innerHTML = s || ''; return t.value; };
  const bqaMoney = (cents, format) => {
    const n = (Number(cents) || 0) / 100;
    const group = (num, dec, th, ds) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return group(n, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return group(n, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return group(n, 0, '.', ',');
      if (key === 'amount_with_apostrophe_separator') return group(n, 2, "'", '.');
      return group(n, 2, ',', '.');
    });
  };
 
  class BeebirQuickAdd extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) {
        // A re-rendered section brings a fresh drawer: drop the old copy, then move this one to <body>.
        document.querySelectorAll(`body > beebir-quick-add[id="${this.id}"]`).forEach((old) => { if (old !== this) old.remove(); });
        document.body.appendChild(this);
        return;
      }
      if (this.ready) return;
      this.ready = true;
      this.money = bqaDecode(this.dataset.money);
      this.qty = 1;
      this.querySelectorAll('[data-qa-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      this.querySelectorAll('[data-qty]').forEach((b) => b.addEventListener('click', () => {
        this.qty = Math.min(99, Math.max(1, this.qty + Number(b.dataset.qty)));
        this.querySelector('[data-qty-n]').textContent = this.qty;
        this.updateBuy();
      }));
      this.querySelector('[data-qa-buy]').addEventListener('click', () => this.buy());
    }
 
    open(card, trigger) {
      const json = card.querySelector('[data-qa-json]');
      if (!json) return;
      let data;
      try { data = JSON.parse(json.textContent); } catch (e) { window.location.href = card.querySelector('[data-link]')?.href; return; }
      const pressed = card.querySelector('[data-swatch][aria-pressed="true"]');
      let idx = pressed ? data.values.findIndex((v) => v.name === bqaDecode(pressed.dataset.name)) : -1;
      if (idx < 0 || !data.values[idx].available) idx = Math.max(0, data.values.findIndex((v) => v.available));
      this.cur = { data, idx, card };
      this.returnTo = trigger;
      this.qty = 1;
      this.querySelector('[data-qty-n]').textContent = '1';
      this.querySelector('[data-qa-name]').textContent = data.title;
      this.querySelector('[data-qa-link]').href = data.url;
      this.querySelector('[data-qa-count]').textContent = data.count + ' ' + data.option.toLowerCase() + (data.count === 1 ? '' : 's');
      this.querySelector('[data-qa-msg]').hidden = true;
 
      const list = this.querySelector('[data-qa-shades]');
      list.innerHTML = '';
      data.values.forEach((v, k) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bqa-s';
        b.setAttribute('role', 'radio');
        b.disabled = !v.available;
        const dot = document.createElement('i');
        if (v.color) dot.style.setProperty('--sw-c', v.color);
        if (v.swatch && !v.color) dot.style.setProperty('--sw-img', `url("${v.swatch}")`);
        b.append(dot, document.createTextNode(v.name));
        b.addEventListener('click', () => this.pick(k));
        list.appendChild(b);
      });
      this.pick(idx);
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bqa-lock');
      setTimeout(() => this.querySelector('.bqa__x')?.focus({ preventScroll: true }), 60);
    }
 
    pick(k) {
      const { data } = this.cur;
      const v = data.values[k];
      if (!v || !v.available) return;
      this.cur.idx = k;
      this.querySelectorAll('.bqa-s').forEach((b, i) => b.setAttribute('aria-checked', String(i === k)));
      this.querySelector('[data-qa-shade]').textContent = data.option + ': ' + v.name;
      const price = this.querySelector('[data-qa-price]');
      price.classList.toggle('is-sale', !!v.was);
      price.innerHTML = '';
      const now = document.createElement('b');
      now.textContent = v.price;
      price.appendChild(now);
      if (v.was) { const was = document.createElement('s'); was.textContent = v.was; price.appendChild(was); }
      const img = this.querySelector('[data-qa-img]');
      img.innerHTML = '';
      if (v.img) { const el = new Image(); el.src = v.img; el.alt = data.title + ' – ' + v.name; img.appendChild(el); }
      this.updateBuy();
    }
 
    updateBuy() {
      const v = this.cur?.data.values[this.cur.idx];
      const b = this.querySelector('[data-qa-buy]');
      b.classList.remove('is-done');
      b.disabled = !v || !v.available;
      b.textContent = (bqaDecode(this.dataset.addLabel) || 'Add to cart') + (v ? ' · ' + bqaMoney(v.cents * this.qty, this.money) : '');
    }
 
    async buy() {
      const v = this.cur?.data.values[this.cur.idx];
      const b = this.querySelector('[data-qa-buy]');
      if (!v || !v.available || b.disabled) return;
      b.disabled = true;
      try {
        await window.BeebirCart.add(v.id, this.qty, false);
        b.classList.add('is-done');
        b.textContent = bqaDecode(this.dataset.added) || 'Added';
        this.cur.card.pickByName?.(v.name);
        setTimeout(() => {
          this.close();
          b.disabled = false;
          document.dispatchEvent(new CustomEvent('beebir:cart:open', { cancelable: true }));
        }, 700);
      } catch (err) {
        b.disabled = false;
        const msg = this.querySelector('[data-qa-msg]');
        msg.textContent = err.message || bqaDecode(this.dataset.error);
        msg.hidden = false;
      }
    }
 
    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bqa-lock');
      this.returnTo?.focus?.({ preventScroll: true });
    }
  }
  customElements.define('beebir-quick-add', BeebirQuickAdd);
}
 